import { useTranslation } from 'react-i18next';

import OrderedList, { OrderedListItem } from 'packages/kakapo-ui-kit/components/lists/OrderedList';
import Column from 'packages/kakapo-ui-kit/components/grid/Column';
import FeedbackRespondInstructionsIllustration from 'packages/kakapo-ui-kit/assets/illustrations/FeedbackRespondInstructionsIllustration';

export default function FeedbackRespondInstructions() {
	const { t } = useTranslation();

	return (
		<>
			<OrderedList title={t('feedback.list.howToGiveFeedback')}>
				<OrderedListItem>{t('feedback.list.howToGiveFeedbackStep1')}</OrderedListItem>
				<OrderedListItem>{t('feedback.list.howToGiveFeedbackStep2')}</OrderedListItem>
				<OrderedListItem>{t('feedback.list.howToGiveFeedbackStep3')}</OrderedListItem>
			</OrderedList>

			<Column py={3} width={2 / 12}>
				<FeedbackRespondInstructionsIllustration width="250" />
			</Column>
		</>
	);
}
